import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import ReactGA from "react-ga4";
import { useSelector } from "react-redux";

export default function GAListener() {
    const location = useLocation();
    const authData = useSelector((state) => state.Auth);

    useEffect(() => {
        const path = location.pathname + location.search;

        ReactGA.send({
            hitType: "pageview",
            page: path,
            title: document.title + location.pathname,
            // Custom Dimensions
            isLoggedIn: authData.isLoggedIn || false,
            schoolClassTestID: authData?.schoolClassTestID || "",
            isTimerCompletePursuit: authData?.isTimerCompletePursuit || false,
            gameScore: authData?.gameScore || "",
            user_role: authData?.role || "",
            school: authData?.profileInfo?.school || "",
            user_id: authData?.profileInfo?.id || "",
            ageRange: authData?.profileInfo?.ageRange || "",
            // plan_type: profileInfo?.plan,
            // app_version: import.meta.env.VITE_APP_VERSION,
        });

        // ReactGA.send({ hitType: "pageview", page: location.pathname + location.search });
    }, [location, authData]);

    return null;
}
